<ion-select
  interface="popover"
  justify="space-between"
  fill="outline"
  [placeholder]="'language.selectLanguage' | transloco"
  [value]="activeLanguage()"
  label=" {{ 'language.selectLanguage' | transloco }}"
  [attr.aria-label]="'language.selectLanguage' | transloco"
  (ionChange)="handleSelectLanguage($event.detail.value)"
>
  @for (language of availableLanguages(); track language) {
    <ion-select-option [value]="language">
      {{ 'language.languages.' + language.toString() | transloco }}
    </ion-select-option>
  }
</ion-select>
